import { render } from "./dialog-loader.vue?vue&type=template&id=1bfc3b82&scoped=true"
import script from "./dialog-loader.ts?vue&type=script&lang=js&external"
export * from "./dialog-loader.ts?vue&type=script&lang=js&external"

import "./dialog-loader.vue?vue&type=style&index=0&id=1bfc3b82&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bfc3b82"]])

export default __exports__